import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const amount = (min: number, max: number, t: TFunction, formattedMinAmount?: string, formattedMaxAmount?: string) =>
    Yup.number()
        .min(min, t<string>('validation:amount.min', { amount: formattedMinAmount ?? min }))
        .typeError(t<string>('validation:amount.typeError'))
        .max(max, t<string>('validation:amount.max', { amount: formattedMaxAmount ?? max }))
        .required(t<string>('validation:amount.required'));

export const amountNotEmpty = (fieldLabel: string, t: TFunction) =>
    Yup.number()
        .typeError(t<string>('validation:amount.requiredZeroForEmpty', { fieldLabel }))
        .required(t<string>('validation:amount.requiredZeroForEmpty', { fieldLabel }));

export const amountNotNull = (t: TFunction) =>
    Yup.number().typeError(t<string>('validation:amount.typeError')).required(t<string>('validation:amount.required'));
